import React from 'react';
import { i18n } from '@international/mastodon-i18n';

import IntlLoginForm from 'components/Reports/IntlLoginForm';
import MainContainer from 'components/MainContainer';
import Loading from 'components/Loading';
import { fetchCandidateReportsIntl, clearLoggedOut } from 'actions';
import ToastNotification from 'components/ToastNotification';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, Navigate } from 'react-router-dom';
import useAuthGateState from 'hooks/useAuthGateState';
import useAuthReady from 'utils/useAuthReady';
import useUnifiedLoginKickoff from 'utils/useUnifiedLoginKickoff';
import { safeReturnPath } from 'utils/returnPath';
import { PATHS } from '../../../constants';

const InternationalLogin: React.FC = () => {
  const { processing, error } = useSelector((state: any) => state.portal);
  const {
    portalAuth: { loggedOut },
  } = useAuthGateState();
  const { loading: authLoading, isLoggedIn, token } = useAuthReady();
  const { holdsLogin: unifiedKickoffHoldsLogin } = useUnifiedLoginKickoff();
  const dispatch = useDispatch();
  const { state, hash } = useLocation();
  const handleSubmit = React.useCallback(
    (values: any) => {
      dispatch(fetchCandidateReportsIntl(values));
    },
    [dispatch],
  );
  if (isLoggedIn || token) {
    const target =
      safeReturnPath(state?.prevLocation) ||
      PATHS.INTERNATIONAL_REPORTS_OVERVIEW;
    return <Navigate to={target} />;
  }
  if (authLoading) {
    return <Loading />;
  }
  if (unifiedKickoffHoldsLogin) {
    return <Loading />;
  }
  if (error && hash.indexOf('login_error') < 0) {
    return <Navigate to='#login_error' state={state} />;
  }
  return (
    <MainContainer>
      {loggedOut && (
        <ToastNotification
          title={i18n.getStr('components.successFullyLoggedOut')}
          kind='success'
          onClose={() => {
            dispatch(clearLoggedOut());
          }}
        />
      )}
      <IntlLoginForm
        onSubmit={handleSubmit}
        processing={processing}
        fetchError={error}
        loginSource='InternationalLoginForm'
      />
    </MainContainer>
  );
};

export default InternationalLogin;
